import React from "react";
import { Jumbotron } from "reactstrap";
import "../assets/styles/ImageJumbotron.scss";

const ImageJumbotron = ({ bg, children }) => (
  <Jumbotron
    style={{
      background: `url(${require("../assets/img/" +
        bg)}) no-repeat center center`,
    }}
  >
    {children}
  </Jumbotron>
);

export default ImageJumbotron;
